import { Http } from '@/core';
import { guard } from '@/utils';
import qs from 'qs';
import {
  AddExternalDocumentDto,
  ExternalDocumentDto,
  UpdateExternalDocumentDto,
} from './externalDocumentTypes';

class ExternalDocumentsHttp extends Http {
  public async getAll(args: { referenceIds: string[] | null }) {
    const query = qs.stringify(args);
    const response = await this._axios.get<ExternalDocumentDto[]>(
      `/api/external-documents?${query}`,
    );
    return response.data;
  }

  public async get(id: string) {
    guard.notNull(id, 'id');
    const response = await this._axios.get<ExternalDocumentDto>(
      `/api/external-documents/${id}`,
    );
    return response.data;
  }

  public async create(request: AddExternalDocumentDto) {
    guard.notNull(request, 'request');
    const response = await this._axios.post<string>(
      '/api/external-documents',
      request,
    );
    return response.data;
  }

  public async update(request: UpdateExternalDocumentDto) {
    guard.notNull(request, 'request');
    await this._axios.put('/api/external-documents', request);
  }

  public async delete(id: string) {
    guard.notNull(id, 'id');
    await this._axios.delete(`/api/external-documents/${id}`);
  }
}

export const externalDocumentsHttp = new ExternalDocumentsHttp();
